import axios from "axios";
import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { showError, showSuccess } from "../../../utils/toastUtils";

// bookingType: "service" | "package"
const CancelBookingModal = ({
  isOpen,
  booking,
  onClose,
  onSuccess,
  bookingType = "service",
}) => {
  const [reason, setReason] = useState("");
  const [isCancelling, setIsCancelling] = useState(false);

  const handleCancel = async () => {
    if (!booking?._id || !reason.trim()) return;
    try {
      setIsCancelling(true);

      if (bookingType === "package") {
        // Package bookings: call package-bookings update endpoint directly
        await axios.put(
          `${process.env.REACT_APP_API_URL}/package-bookings/${booking._id}`,
          {
            status: "cancelled",
            cancelReason: reason,
          },
        );
      } else {
        // Service bookings: use existing staff-assignment endpoint (unchanged)
        await axios.put(
          `${process.env.REACT_APP_API_URL}/staff-assignment/update-status`,
          {
            bookingId: booking._id,
            status: "cancelled",
            cancelReason: reason,
          },
        );
      }

      showSuccess("Cancelled successfully");
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Cancel failed", error);
      showError(error?.response?.data?.message || "Failed to cancel");
    } finally {
      setIsCancelling(false);
      setReason("");
    }
  };

  if (!isOpen || !booking) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3">
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-[420px] bg-white rounded-2xl p-6 space-y-5 animate-modal-in shadow-xl"
      >
        {/* Header */}
        <div className="relative text-center">
          <button
            onClick={onClose}
            className="absolute right-0 top-0 p-1 rounded-full active:bg-gray-100"
          >
            <X size={18} />
          </button>
          <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-3">
            <AlertTriangle className="text-red-500" size={22} />
          </div>
          <h3 className="text-lg font-semibold text-primaryTextColor">
            Cancel Booking?
          </h3>
          <p className="text-sm text-secondaryTextColor mt-1">
            Please tell us why you're cancelling. This helps keep records clear.
          </p>
        </div>

        {/* Reason Input */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-primaryTextColor">
            Cancellation Reason <span className="text-red-500">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="e.g. Customer unavailable, location issue, emergency…"
            className="w-full resize-none rounded-xl border border-gray-300 px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-red-600"
          />
        </div>

        {/* Actions */}
        <div className="space-y-3 pt-2">
          <button
            onClick={handleCancel}
            disabled={!reason.trim() || isCancelling}
            className={`w-full h-12 rounded-xl font-semibold text-white transition ${reason.trim()
              ? "bg-red-600 active:bg-red-700"
              : "bg-red-300 cursor-not-allowed"
              }`}
          >
            {isCancelling ? (
              <div className="flex items-center justify-center gap-1">
                <CgSpinner className="animate-spin" size={18} />
                Cancelling…
              </div>
            ) : (
              "Yes, Cancel"
            )}
          </button>
          <button
            onClick={onClose}
            className="w-full h-10 rounded-xl text-secondaryTextColor font-medium active:bg-gray-100"
          >
            Keep Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelBookingModal;







// import axios from "axios";
// import { AlertTriangle, X } from "lucide-react";
// import { useState } from "react";
// import { CgSpinner } from "react-icons/cg";
// import { showError, showSuccess } from "../../../utils/toastUtils";

// const CancelBookingModal = ({ isOpen, booking, onClose, onSuccess }) => {
//   const [reason, setReason] = useState("");
//   const [isCancelling, setIsCancelling] = useState(false);

//   const handleCancel = async () => {
//     if (!booking?._id || !reason.trim()) return;

//     try {
//       setIsCancelling(true);

//       await axios.put(
//         `${process.env.REACT_APP_API_URL}/staff-assignment/update-status`,
//         {
//           bookingId: booking._id,
//           status: "cancelled",
//           cancelReason: reason,
//         }
//       );

//       showSuccess("Cancelled successfully");
//       onSuccess?.();
//       onClose();
//     } catch (error) {
//       console.error("Cancel failed", error);
//       showError("Failed to cancel");
//     } finally {
//       setIsCancelling(false);
//       setReason("");
//     }
//   };

//   if (!isOpen || !booking) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3">
//       <div
//         onClick={(e) => e.stopPropagation()}
//         className="w-full max-w-[420px] bg-white rounded-2xl p-6 space-y-5 animate-modal-in shadow-xl"
//       >
//         {/* Header */}
//         <div className="relative text-center">
//           <button
//             onClick={onClose}
//             className="absolute right-0 top-0 p-1 rounded-full active:bg-gray-100"
//           >
//             <X size={18} />
//           </button>

//           <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-3">
//             <AlertTriangle className="text-red-500" size={22} />
//           </div>

//           <h3 className="text-lg font-semibold text-primaryTextColor">
//             Cancel Booking?
//           </h3>
//           <p className="text-sm text-secondaryTextColor mt-1">
//             Please tell us why you’re cancelling. This helps keep records clear.
//           </p>
//         </div>

//         {/* Reason Input */}
//         <div className="space-y-1.5">
//           <label className="text-sm font-medium text-primaryTextColor">
//             Cancellation Reason <span className="text-red-500">*</span>
//           </label>
//           <textarea
//             value={reason}
//             onChange={(e) => setReason(e.target.value)}
//             rows={3}
//             placeholder="e.g. Customer unavailable, location issue, emergency…"
//             className="w-full resize-none rounded-xl border border-gray-300 px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-red-600"
//           />
//         </div>

//         {/* Actions */}
//         <div className="space-y-3 pt-2">
//           <button
//             onClick={handleCancel}
//             disabled={!reason.trim() || isCancelling}
//             className={`w-full h-12 rounded-xl font-semibold text-white transition ${
//               reason.trim()
//                 ? "bg-red-600 active:bg-red-700"
//                 : "bg-red-300 cursor-not-allowed"
//             }`}
//           >
//             {isCancelling ? (
//               <div className="flex items-center justify-center gap-1">
//                 <CgSpinner className="animate-spin" size={18} />
//                 Cancelling…
//               </div>
//             ) : (
//               "Yes, Cancel"
//             )}
//           </button>

//           <button
//             onClick={onClose}
//             className="w-full h-10 rounded-xl text-secondaryTextColor font-medium active:bg-gray-100"
//           >
//             Keep Booking
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CancelBookingModal;
